import * as util from './util.js';
export default class ABIEvent {
    constructor(eventABI) {
        this.eventId = util.getId(eventABI);
        this.abi = { ...eventABI, eventId: this.eventId };
        // indexed parameters included in log topics, not in log data
        const unindexedInputs = eventABI.inputs.filter((input) => input.indexed === false);
        this.parse = (data) => {
            return util.parseAndFormat(unindexedInputs, data);
        };
    }
    build() {
        throw new Error('build is unimplemented for events');
    }
    testInput() {
        throw new Error('testInput is unimplemented for events');
    }
}
